import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class VersionCheckHelper {
  private currentVersion: string | null = null;
  private failureCount = 0;
  private maxFailures = 3;
  private intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(private http: HttpClient) {}

  public async initVersionCheck(url: string, frequency = 1000 * 60 * 30) {
    await this.checkVersion(url);
    // Start polling, stored for potential cleanup
    this.intervalId = setInterval(() => this.checkVersion(url), frequency);
  }

  private async checkVersion(url: string) {
    try {
      const response: any = await firstValueFrom(
        this.http.get(`${url}?t=${new Date().getTime()}`)
      );

      const serverVersion = response.version;

      if (!serverVersion) {
        return;
      }

      // Reset failure count on success
      this.failureCount = 0;

      if (!this.currentVersion) {
        this.currentVersion = serverVersion;
        return;
      }

      if (this.currentVersion !== serverVersion) {
        console.log("Versi baru ditemukan! Melakukan reload...");
        window.location.reload();
      }
    } catch (err) {
      this.failureCount++;
      console.warn(
        `Version check failed (${this.failureCount}/${this.maxFailures}):`,
        err
      );

      // Stop polling after repeated failures to avoid spam
      if (this.failureCount >= this.maxFailures && this.intervalId) {
        console.warn("Stopping version polling after repeated failures");
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  }
}
